import React from 'react';
import './loader.css';

class Loader extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            count: 0
        }
    }

    componentDidMount() {
        setInterval(() => {
            if (this.state.count < 100) {
                this.setState({
                    count: this.state.count + 1
                })
            } else {
                this.setState({
                    count: 100
                })
            }
        }, 150);
    }

    componentWillUnmount() {
        this.setState({
            count: 100
        })
    }

    render() {

        const { count } = this.state

        return (
            <div>
                <div className="loader_bg">
                    <div className="loader_content">
                        <h4>{count}<span>%</span></h4>
                        <img src="/assets/img/img-14.png" className="img-fluid" alt="" />
                    </div>
                </div>
            </div>

        )
    }
}

export default Loader;